angular.module('unergie.main')
.controller('eventRulesModalCtrl', ($scope, $timeout, $uibModalInstance, DataAccess, resource, id, AlertManager, ErrorCatcher) => {
    const ruleTemplate = {
        resource,
        status: 'INITIAL',
        id_resource: id,
        conditions: {},
        targets: {},
        edit: true,
    }

    $scope.eventRules = undefined
    $scope.eventRulesRef = undefined

    let condFields = {}
    let targetFields = {}

    const condTemplate = {
        name: '',
    }

    const targetTemplate = {
        name: '',
    }

    const filterFieldsForRule = function (rule) {
        rule.condFields = angular.copy(condFields)
        rule.targetFields = angular.copy(targetFields)
        _.remove(rule.condFields.name.enum, (elem) => rule.conditions[elem.value] !== undefined)
        return _.remove(rule.targetFields.name.enum, (elem) => rule.targets[elem.value] !== undefined)
    }

    $scope.possibleCondValues = (condName) => $scope.eventRulesRef.conditions[condName].possibleValues

    $scope.possibleTargetValues = (targetName) => $scope.eventRulesRef.targets[targetName].possibleValues

    $scope.deleteCondition = function (rule, cond) {
        delete rule.conditions[cond]
        return filterFieldsForRule(rule)
    }

    $scope.deleteTarget = function (rule, target) {
        delete rule.targets[target]
        return filterFieldsForRule(rule)
    }

    const resetCondPayload = () => ($scope.condPayload = angular.copy(condTemplate))
    const resetTargetPayload = () => ($scope.targetPayload = angular.copy(targetTemplate))

    $scope.cancelEdit = () => $scope.refresh()

    const refreshRef = () =>
        DataAccess.getEventRulesRef().$promise.then((eventRulesRef) => {
            $scope.eventRulesRef = eventRulesRef.toJSON()
            const conds = []
            const targets = []
            _.forEach($scope.eventRulesRef.conditions, (cond, condName) => {
                if (cond.resource === resource) {
                    return conds.push({ value: condName, label: `${condName} - ${cond.description}` })
                }
            })
            _.forEach($scope.eventRulesRef.targets, (target, targetName) => {
                if (target.resource === resource) {
                    return targets.push({ value: targetName, label: `${targetName} - ${target.description}` })
                }
            })
            condFields = {
                name: {
                    required: true,
                    label: 'Condition',
                    type: 'select',
                    enum: conds,
                },
            }
            targetFields = {
                name: {
                    required: true,
                    label: 'Conséquence',
                    type: 'select',
                    enum: targets,
                },
            }

            return targetFields
        })
        .catch(ErrorCatcher)


    $scope.showAddCond = (rule) => rule.condFields.name.enum.length > 0

    $scope.showAddTarget = (rule) => rule.targetFields.name.enum.length > 0

    $scope.refresh = () =>
        DataAccess.getEventRules({ resource, id_resource: id }).$promise.then((eventRules) => {
            $scope.eventRules = eventRules
            return _.forEach($scope.eventRules, (rule) => filterFieldsForRule(rule)) }).catch(ErrorCatcher)


    refreshRef().then(() => $scope.refresh())

    $scope.addCondition = function (rule) {
        let value = ''
        const possibleValues = $scope.possibleCondValues($scope.condPayload.name)
        if (angular.isArray(possibleValues)) {
            value = possibleValues[0]
        }
        rule.conditions[$scope.condPayload.name] = value
        filterFieldsForRule(rule)
        return resetCondPayload()
    }

    $scope.addTarget = function (rule) {
        let value = ''
        const possibleValues = $scope.possibleTargetValues($scope.targetPayload.name)
        if (angular.isArray(possibleValues)) {
            value = possibleValues[0]
        }
        rule.targets[$scope.targetPayload.name] = value
        filterFieldsForRule(rule)
        return resetTargetPayload()
    }

    $scope.saveRule = function (rule) {
        if (Object.keys(rule.conditions).length === 0) {
            AlertManager.error('Une règle nécessite au moins une condition')
            return
        }
        if (Object.keys(rule.targets).length === 0) {
            AlertManager.error('Une règle nécessite au moins une conséquence')
            return
        }
        delete rule.edit
        const payload = angular.copy(rule)
        delete payload.condFields
        delete payload.targetFields
        const related = []
        _.forEach(payload.conditions, (value, key) => {
            if ($scope.eventRulesRef.conditions[key].related) {
                return related.push($scope.eventRulesRef.conditions[key].related)
            }
        })
        payload.relations = _.uniq(related).join(',')
        if (payload.id) {
            delete payload.id
            return DataAccess.saveEventRules({ id: rule.id }, payload).$promise.then(() => {
                AlertManager.success('Règle enregistrée')
                return $scope.refresh() }).catch(ErrorCatcher)
        }
        return DataAccess.addEventRules(payload).$promise.then(() => {
            AlertManager.success('Règle ajoutée')
            return $scope.refresh() }).catch(ErrorCatcher)
    }

    resetCondPayload()
    resetTargetPayload()

    $scope.isArray = angular.isArray

    $scope.addRule = function () {
        const rule = angular.copy(ruleTemplate)
        filterFieldsForRule(rule)
        return $scope.eventRules.push(rule)
    }

    $scope.deleteRule = (rule) =>
        DataAccess.deleteEventRules({ id: rule.id }).$promise.then(() => {
            AlertManager.success('Règle supprimée')
            return $scope.refresh() }).catch(ErrorCatcher)


    // RETURN OK
    $scope.ok = () => $uibModalInstance.close()

    return ($uibModalInstance.dismiss = $scope.ok)
})
